<ng-container>
  <div class="operator-input-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    <div class="scope-criteria field">
      <label soho-label for="periodCategory">{{ 'FieldPicker_periodOperatorCategory_label' | translate }}</label>
      <select
        id="periodCategory"
        soho-dropdown
        noSearch
        name="periodCategory"
        data-automation-id="lm-field-picker-period-category"
        (change)="onOperatorChange('periodCategory')"
        [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.category"
        [ngClass]="'dropdown-md'">
        <option [value]="'period'">{{ 'FieldPicker_periodOption_label' | translate }}</option>
        <option [value]="'periodRange'">{{ 'FieldPicker_periodRangeOption_label' | translate }}</option>
        <option [value]="'beginning balance'">{{ 'FieldPicker_beginningBalanceOption_label' | translate }}</option>
        <option [value]="'beginning ytd balance'">{{ 'FieldPicker_ytdBeginningBalanceOption_label' | translate }}</option>
        <option [value]="'ending balance'">{{ 'FieldPicker_endingBalanceOption_label' | translate }}</option>
        <option [value]="'ending ytd balance'">{{ 'FieldPicker_ytdEndingBalanceOption_label' | translate }}</option>
      </select>
    </div>
  </div>
  <div class="operator-input-container" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
    @if (true) {
      <div class="scope-criteria field">
        <label soho-label for="yearOperator">{{ 'FieldPicker_yearOperator_label' | translate }}</label>
        <select
          id="yearOperator"
          soho-dropdown
          noSearch
          name="yearOperator"
          data-automation-id="lm-field-picker-period-year-operator"
          (change)="onOperatorChange('yearOperator')"
          [(ngModel)]="operatorInfo.periodOperatorInfo.yearInfo.yearOperator"
          [ngClass]="'dropdown-md'">
          <option class="clear"></option>
          <option [value]="'prior year'">{{ 'FieldPicker_priorOption_label' | translate }}</option>
          <option [value]="'next year'">{{ 'FieldPicker_nextOption_label' | translate }}</option>
        </select>
      </div>
      <div class="scope-criteria field">
        <label soho-label for="year">{{ 'FieldPicker_yearShift_label' | translate }}</label>
        <input
          id="year"
          class="input-xs"
          disabled="{{!operatorInfo.periodOperatorInfo.yearInfo.yearOperator}}"
          data-automation-id="lm-field-picker-period-year-shift"
          soho-spinbox
          data-options="{ min:1 }"
          [attr.maxlength]="1"
          (change)="onOperatorChange('year')"
          (keyup)="onOperatorChange('year')"
          [(ngModel)]="operatorInfo.periodOperatorInfo.yearInfo.year"/>
        </div>
      }
      @if (operatorInfo.periodOperatorInfo.periodInfo?.category === 'periodRange') {
        <div class="scope-criteria field">
          <label
            soho-label
            [required]="true"
          for="periodRangeOperator">{{ 'FieldPicker_period_label' | translate }}</label>
          <select
            id="periodRangeOperator"
            soho-dropdown
            noSearch
            name="periodOperator"
            data-automation-id="lm-field-picker-period-operator"
            (change)="onOperatorChange('periodOperator')"
            [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.periodOperator"
            [ngClass]="'dropdown-md'">
            @for (option of validPeriodsForMeasuresOnly; track option) {
              <option [value]="option.value">{{option.label}}</option>
            }
          </select>
        </div>
        @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'period') {
          <div class="scope-criteria field">
            <label
              data-automation-id="lm-field-picker-period-from-label"
              soho-label
            for="periodRangePeriod">{{'FieldPicker_from_label' | translate }}</label>
            <input
              id="periodRangePeriod"
              data-automation-id="lm-field-picker-period-from"
              class="input-sm"
              soho-spinbox
              data-options="{ min:1 }"
              [attr.maxlength]="3"
              (change)="onOperatorChange('periodFrom')"
              (keyup)="onOperatorChange('periodFrom')"
              [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
            </div>
            <div class="scope-criteria field">
              <label
                data-automation-id="lm-field-picker-period-thru-label"
                soho-label
              for="periodRangeToPeriod">{{'FieldPicker_thru_label' | translate }}</label>
              <input
                id="periodRangeToPeriod"
                data-automation-id="lm-field-picker-period-thru"
                class="input-sm"
                soho-spinbox
                data-options="{ min:0 }"
                [attr.maxlength]="3"
                (change)="onOperatorChange('periodTo')"
                (keyup)="onOperatorChange('periodTo')"
                [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.to"/>
              </div>
            }
            @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'week') {
              <div class="scope-criteria field">
                <label
                  data-automation-id="lm-field-picker-period-from-label"
                  soho-label
                for="periodRangeWeek">{{'FieldPicker_from_label' | translate }}</label>
                <input
                  id="periodRangeWeek"
                  data-automation-id="lm-field-picker-period-from"
                  class="input-xs"
                  soho-spinbox
                  data-options="{ min:0, max:53 }"
                  (change)="onOperatorChange('periodFrom')"
                  (keyup)="onOperatorChange('periodFrom')"
                  [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                </div>
                <div class="scope-criteria field">
                  <label
                    data-automation-id="lm-field-picker-period-thru-label"
                    soho-label
                  for="periodRangeToWeek">{{'FieldPicker_thru_label' | translate }}</label>
                  <input
                    id="periodRangeToWeek"
                    data-automation-id="lm-field-picker-period-thru"
                    class="input-xs"
                    soho-spinbox
                    data-options="{ min:0, max:53 }"
                    (change)="onOperatorChange('periodTo')"
                    (keyup)="onOperatorChange('periodTo')"
                    [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.to"/>
                  </div>
                }
                @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'month') {
                  <div class="scope-criteria field">
                    <label
                      data-automation-id="lm-field-picker-period-from-label"
                      soho-label
                    for="periodRangeMonth">{{'FieldPicker_from_label' | translate }}</label>
                    <input
                      id="periodRangeMonth"
                      data-automation-id="lm-field-picker-period-from"
                      class="input-xs"
                      soho-spinbox
                      data-options="{ min:0, max:12 }"
                      (change)="onOperatorChange('periodFrom')"
                      (keyup)="onOperatorChange('periodFrom')"
                      [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                    </div>
                    <div class="scope-criteria field">
                      <label
                        data-automation-id="lm-field-picker-period-thru-label"
                        soho-label
                      for="periodRangeToMonth">{{'FieldPicker_thru_label' | translate }}</label>
                      <input
                        id="periodRangeToMonth"
                        data-automation-id="lm-field-picker-period-thru"
                        class="input-xs"
                        soho-spinbox
                        data-options="{ min:1, max:12 }"
                        (change)="onOperatorChange('periodTo')"
                        (keyup)="onOperatorChange('periodTo')"
                        [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.to"/>
                      </div>
                    }
                    @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'quarter') {
                      <div class="scope-criteria field">
                        <label
                          data-automation-id="lm-field-picker-period-from-label"
                          soho-label
                        for="periodRangeQuarter">{{'FieldPicker_from_label' | translate }}</label>
                        <input
                          id="periodRangeQuarter"
                          data-automation-id="lm-field-picker-period-from"
                          class="input-xs"
                          soho-spinbox
                          data-options="{ min:1, max:4 }"
                          (change)="onOperatorChange('periodFrom')"
                          (keyup)="onOperatorChange('periodFrom')"
                          [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                        </div>
                        <div class="scope-criteria field">
                          <label
                            data-automation-id="lm-field-picker-period-thru-label"
                            soho-label
                          for="periodRangeToQuarter">{{'FieldPicker_thru_label' | translate }}</label>
                          <input
                            id="periodRangeToQuarter"
                            data-automation-id="lm-field-picker-period-thru"
                            class="input-xs"
                            soho-spinbox
                            data-options="{ min:1, max:4 }"
                            (change)="onOperatorChange('periodTo')"
                            (keyup)="onOperatorChange('periodTo')"
                            [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.to"/>
                          </div>
                        }
                        @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'year') {
                          <div class="scope-criteria field">
                            <label
                              data-automation-id="lm-field-picker-period-from-label"
                              soho-label
                              [required]="operatorInfo.periodOperatorInfo.periodInfo?.category === 'periodRange'"
                            for="periodRangeYear">{{'FieldPicker_from_label' |translate }}</label>
                            <input
                              id="periodRangeYear"
                              data-automation-id="lm-field-picker-period-from"
                              class="input-sm"
                              soho-spinbox
                              [attr.maxlength]="4"
                              data-options="{ min:1900, max:3000 }"
                              (change)="onOperatorChange('periodFrom')"
                              (keyup)="onOperatorChange('periodFrom')"
                              [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                            </div>
                            <div class="scope-criteria field">
                              <label
                                data-automation-id="lm-field-picker-period-thru-label"
                                soho-label
                                [required]="operatorInfo.periodOperatorInfo.periodInfo?.category === 'periodRange'"
                              for="periodRangeToYear">{{'FieldPicker_thru_label' |translate }}</label>
                              <input
                                id="periodRangeToYear"
                                data-automation-id="lm-field-picker-period-thru"
                                class="input-sm"
                                soho-spinbox
                                [attr.maxlength]="4"
                                data-options="{ min:1900, max:3000 }"
                                (change)="onOperatorChange('periodTo')"
                                (keyup)="onOperatorChange('periodTo')"
                                [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.to"/>
                              </div>
                            }
                          } @else {
                            <div class="scope-criteria field">
                              <label soho-label for="periodPriorNext">{{ 'ColumnEditorPeriodOperatorLabel' | translate }}</label>
                              <select
                                id="periodPriorNext"
                                soho-dropdown
                                noSearch
                                name="periodPriorNext"
                                data-automation-id="lm-field-picker-period-period-prior-next"
                                (change)="onOperatorChange('periodPriorNext')"
                                [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.priorNext"
                                [ngClass]="'dropdown-md'">
                                <option class="clear"></option>
                                <option [value]="'prior'">{{ 'FieldPicker_priorOption_label' | translate }}</option>
                                <option [value]="'next'">{{ 'FieldPicker_nextOption_label' | translate }}</option>
                              </select>
                            </div>
                            <div class="scope-criteria field">
                              <label
                                soho-label
                                [required]="false"
                              for="periodOperator">{{ 'FieldPicker_period_label' | translate }}</label>
                              <select
                                id="periodOperator"
                                soho-dropdown
                                noSearch
                                name="periodOperator"
                                data-automation-id="lm-field-picker-period-operator"
                                (change)="onOperatorChange('periodOperator')"
                                [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.periodOperator"
                                [ngClass]="'dropdown-md'">
                                @for (option of validPeriodsForMeasuresOnly; track option) {
                                  <option [value]="option.value">{{option.label}}</option>
                                }
                              </select>
                            </div>
                            @if (operatorInfo.periodOperatorInfo.periodInfo?.priorNext === 'next' || operatorInfo.periodOperatorInfo.periodInfo?.priorNext === 'prior') {
                              <div class="scope-criteria field">
                                <label
                                  data-automation-id="lm-field-picker-period-from-label"
                                  soho-label
                                for="periodShift">{{'FieldPicker_shift_label' | translate }}</label>
                                <input
                                  id="periodShift"
                                  data-automation-id="lm-field-picker-period-from"
                                  class="input-xs"
                                  soho-spinbox
                                  data-options="{ min:1 }"
                                  [attr.maxlength]="3"
                                  (change)="onOperatorChange('periodFrom')"
                                  (keyup)="onOperatorChange('periodFrom')"
                                  [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                                </div>
                              }
                              @if (operatorInfo.periodOperatorInfo.periodInfo?.priorNext !== 'next' && operatorInfo.periodOperatorInfo.periodInfo?.priorNext !== 'prior') {
                                @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'period') {
                                  <div class="scope-criteria field">
                                    <label
                                      data-automation-id="lm-field-picker-period-from-label"
                                      soho-label
                                    for="periodPeriod">{{'FieldPicker_number_label' | translate }}</label>
                                    <input
                                      id="periodPeriod"
                                      data-automation-id="lm-field-picker-period-from"
                                      class="input-sm"
                                      soho-spinbox
                                      data-options="{ min:0 }"
                                      [attr.maxlength]="3"
                                      (change)="onOperatorChange('periodFrom')"
                                      (keyup)="onOperatorChange('periodFrom')"
                                      [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                                    </div>
                                  }
                                  @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'week') {
                                    <div class="scope-criteria field">
                                      <label
                                        data-automation-id="lm-field-picker-period-from-label"
                                        soho-label
                                      for="periodWeek">{{'FieldPicker_weekOption_label' | translate }}</label>
                                      <input
                                        id="periodWeek"
                                        data-automation-id="lm-field-picker-period-from"
                                        class="input-xs"
                                        soho-spinbox
                                        data-options="{ min:0, max:53 }"
                                        (change)="onOperatorChange('periodFrom')"
                                        (keyup)="onOperatorChange('periodFrom')"
                                        [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                                      </div>
                                    }
                                    @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'month') {
                                      <div class="scope-criteria field">
                                        <label
                                          data-automation-id="lm-field-picker-period-from-label"
                                          soho-label
                                        for="periodMonth">{{'FieldPicker_monthOption_label' | translate }}</label>
                                        <input
                                          id="periodMonth"
                                          data-automation-id="lm-field-picker-period-from"
                                          class="input-xs"
                                          soho-spinbox
                                          data-options="{ min:0, max:12 }"
                                          (change)="onOperatorChange('periodFrom')"
                                          (keyup)="onOperatorChange('periodFrom')"
                                          [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                                        </div>
                                      }
                                      @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'quarter') {
                                        <div class="scope-criteria field">
                                          <label
                                            data-automation-id="lm-field-picker-period-from-label"
                                            soho-label
                                          for="periodQuarter">{{'FieldPicker_quarterOption_label' | translate }}</label>
                                          <input
                                            id="periodQuarter"
                                            data-automation-id="lm-field-picker-period-from"
                                            class="input-xs"
                                            soho-spinbox
                                            data-options="{ min:0, max:4 }"
                                            (change)="onOperatorChange('periodFrom')"
                                            (keyup)="onOperatorChange('periodFrom')"
                                            [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                                          </div>
                                        }
                                        @if (operatorInfo.periodOperatorInfo.periodInfo.periodOperator === 'year') {
                                          <div class="scope-criteria field">
                                            <label
                                              data-automation-id="lm-field-picker-period-from-label"
                                              soho-label
                                              [required]="operatorInfo.periodOperatorInfo.periodInfo?.category === 'periodRange'"
                                            for="periodYear">{{'FieldPicker_yearOption_label' |translate }}</label>
                                            <input
                                              id="periodYear"
                                              data-automation-id="lm-field-picker-period-from"
                                              class="input-sm"
                                              soho-spinbox
                                              [attr.maxlength]="4"
                                              data-options="{ min:1900, max:3000 }"
                                              (change)="onOperatorChange('periodFrom')"
                                              (keyup)="onOperatorChange('periodFrom')"
                                              [(ngModel)]="operatorInfo.periodOperatorInfo.periodInfo.from"/>
                                            </div>
                                          }
                                        }
                                      }
                                    </div>
                                  </ng-container>



